// extracted by mini-css-extract-plugin
export default {"backLink":"BookingWindow_backLink__dKcIH","tabletWindow":"BookingWindow_tabletWindow__k81cE"};